module.exports = __webpack_public_path__ + "img/d32b4ef.jpg";